"use client";

import cn from "classnames";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Icon, IconType } from "@/components/Icon";

import styles from "./Logo.module.scss";

interface LogoProps {
  containerClassName?: string;
}

type LogoLang = "rus" | "eng";

export const Logo = observer(function Logo(props: LogoProps) {
  const { containerClassName } = props;
  const { i18n } = useTranslation();

  const containerClasses = cn(containerClassName, styles.container);

  const lang: LogoLang = i18n.language === "ru" ? "rus" : "eng";

  const icon: Record<LogoLang, IconType> = {
    eng: "logo-eng",
    rus: "logo-rus",
  };

  return <Icon containerClassName={containerClasses} icon={icon[lang]} />;
});
